import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Tooltip, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { LocalizationProvider, TimeField } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';



function DriversServicePreferences() {

  return (
    <Box display='flex' flexDirection='row' justifyContent='center' sx={{ marginBlockEnd: '0.5rem'}}>
     <Accordion sx={{ width: '100%', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;'}}>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">Preenchimento dos Serviços pelo Motorista</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{margin: '1rem'}}>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Ativar pré-preenchimento dos serviços segundo a Folha de Ponto Virtual</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <RadioGroup row defaultValue="true" name="radio-buttons-group">
                    <FormControlLabel control={<Radio />} label="Sim"/>
                    <FormControlLabel control={<Radio />} label="Não"/>
              </RadioGroup>
              <FormControl size="medium" sx={{ minWidth: 180, width: '50%', bgcolor: 'white' }} fullWidth>
                  <InputLabel>Aplicar a Serviços do Tipo</InputLabel>
                  <Select
                      size="small"
                      value={'0'} displayEmpty required={true} label={"Aplicar a Serviços do Tipo"}>
                      <MenuItem value={'Transol'}>Todos</MenuItem>
                      <MenuItem value={'Cityrama'}>Anabela</MenuItem>
                      <MenuItem value={'Rodest'}>Eunildes</MenuItem>
                  </Select>
              </FormControl>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Inconformidade da Hora de Início após</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'center'}}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimeField size="small" format="HH:mm" label="Início de Serviço" variant="outlined"  />
              </LocalizationProvider>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white', marginInlineStart: '0.5rem' }} fullWidth>
                <RadioGroup row defaultValue="true" name="radio-buttons-group">
                  <FormControlLabel labelPlacement="end" control={<Checkbox checked={true} />} 
                  label='Justificação obrigatória' />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Inconformidade da Hora de Fim após</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'center'}}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimeField size="small" format="HH:mm"  label="Início de Serviço" variant="outlined"  />
              </LocalizationProvider>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white', marginInlineStart: '0.5rem' }} fullWidth>
                <RadioGroup row defaultValue="true" name="radio-buttons-group">
                  <FormControlLabel labelPlacement="end" control={<Checkbox checked={true} />} 
                  label='Justificação obrigatória' />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Inconformidade da Lotação do Serviço</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'center'}}>
              <FormControl size="small" sx={{ minWidth: 180, width: '100%', bgcolor: 'white' }} fullWidth>
                <RadioGroup row defaultValue="true" name="radio-buttons-group">
                  <FormControlLabel labelPlacement="end" control={<Checkbox checked={true} />} 
                  label='Sim, se o número de passageiros for superior ao definido' />
                  <FormControlLabel labelPlacement="end" control={<Checkbox checked={false} />} 
                  label='Sim, se o número de passageiros for inferior ao definido' />
                </RadioGroup>
                <Divider  variant="middle" sx={{width: '80%'}} />
                <RadioGroup row defaultValue="true" name="radio-buttons-group">
                  <FormControlLabel labelPlacement="end" control={<Checkbox checked={true} />} 
                  label='Justificação obrigatória' />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', marginBlock: '1rem'}}>
            <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
                <Typography variant="body1">Estado pré-definido da conformidade da Limpeza da Viatura</Typography>
                <Tooltip title="Open settings" sx={{ marginBlockStart: '0.2rem', marginInlineStart: '0.5rem'}}>
                  <InfoOutlinedIcon fontSize="small"/>
                </Tooltip>
              </Box>
            </Box>
            <Box sx={{ margin: '0rem 1rem 0 1rem', width: '50%', display: 'flex', justifyContent: 'flex-start'}}>
              <RadioGroup row defaultValue="true" name="radio-buttons-group">
                    <FormControlLabel control={<Radio />} label="Estado Selecionado: Sim"/>
                    <FormControlLabel control={<Radio />} label="Estado Selecionado: Não"/>
              </RadioGroup>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default DriversServicePreferences;